export class DepartmentModel {
  departmentId: number = 0;
  countryId: number = 0;
  name: string = '';
  code: string = '';
}